export default {
  en: {
    common: {
      pageTitle: 'Telekom',

      lang_en: 'English',
      lang_de: 'Deutsch',

      logoClaim: 'Telekom, Life is for sharing.',
      loginTitle: 'Trinity Customer Care GUI',
      loginHeader: 'Please enter your user name and password',
      username: 'User name',
      password: 'Password',
      language: 'Language',
      btnLogin: 'Login',
      natco: 'Natco',
      environment: 'Environment',
      version: 'Version',
      headerError: 'Please notice',
      errorDefault: 'An unexpected error occurred!',
      invalidFormData: 'Please fill the fields "User name" and "Password".',
      errorId: 'ID',
      sessionTimeout: {
        title: 'Timeout',
        message: 'You will be logged out shortly',
        stayLoggedIn: 'Stay logged in',
      },

      footer:
        '<li><a href="https://www.telekom.de/start/impressum" target="_blank">Imprint</a></li>     <li><a href="https://www.telekom.de/agb" target="_blank">Terms and conditions</a></li>     <li><a href="https://www.telekom.de/start/haftungsausschluss" target="_blank">Disclaimer</a></li>     <li><a href="https://www.telekom.de/datenschutz-ganz-einfach" target="_blank">Data privacy</a></li>',
      copyright: '&copy; Telekom Deutschland GmbH',
      loading: 'Loading',
      headerLogin: 'Login',
      retry: 'Retry',
      skip_to: 'Skip to main content',
      close: 'Close',
      back: 'Back',
      navigationOpen: 'Main menu',
      aria_label_text_home: 'Home',
    },
    errorcodes: {
      BACKEND_ERROR: 'An unexpected error occurred!',
      BACKEND_ERROR_FATAL: 'An unexpected error occurred!',
      INVALID_TARGET_VIEW: 'Invalid view!',
      NO_ACCESS_PERMISSION: "You don't have permission to access this page!",
    },
  },
  de: {
    common: {
      pageTitle: 'Telekom',

      lang_en: 'English',
      lang_de: 'Deutsch',

      logoClaim: 'Telekom, Erleben was verbindet.',
      loginTitle: 'Trinity Kundenservice GUI',
      loginHeader: 'Bitte geben Sie Ihren Benutzernamen und ihr Passwort ein',
      username: 'Benutzername',
      password: 'Passwort',
      language: 'Sprache',
      btnLogin: 'Anmelden',
      natco: 'Natco',
      environment: 'Systemumgebung',
      version: 'Version',
      headerError: 'Hinweis',
      errorDefault: 'Es ist ein unerwarteter Fehler aufgetreten!',
      invalidFormData: 'Bitte füllen Sie die Felder "Benutzername" und "Passwort".',
      errorId: 'ID',
      sessionTimeout: {
        title: 'Timeout',
        message: 'Sie werden in Kürze abgemeldet',
        stayLoggedIn: 'Angemeldet bleiben',
      },

      footer:
        '<li><a href="https://www.telekom.de/start/impressum" target="_blank">Impressum</a></li>     <li><a href="https://www.telekom.de/agb" target="_blank">AGB</a></li>     <li><a href="https://www.telekom.de/start/haftungsausschluss" target="_blank">Haftungsausschluss</a></li>     <li><a href="https://www.telekom.de/datenschutz-ganz-einfach" target="_blank">Datenschutz</a></li>',
      copyright: '&copy; Telekom Deutschland GmbH',
      loading: 'Wird geladen',
      headerLogin: 'Login',
      retry: 'Erneut versuchen',
      skip_to: 'Zum Inhalt springen',
      close: 'Schließen',
      back: 'Zurück',
      navigationOpen: 'Hauptmenü',
      aria_label_text_home: 'Startseite',
    },
    errorcodes: {
      BACKEND_ERROR: 'Es ist ein unerwarteter Fehler aufgetreten!',
      BACKEND_ERROR_FATAL: 'Es ist ein unerwarteter Fehler aufgetreten!',
      INVALID_TARGET_VIEW: 'Ungültige Seite!',
      NO_ACCESS_PERMISSION: 'Sie haben keinen Zugriff zu dieser Seite!',
    },
  },
};
